import React, { useEffect, useState } from "react";
import "./gallery.css";
import load from "./load.json";
import Header from "../../common_components/Header";
import Footer from "../../common_components/Footer";
function Gallery() {
  const [data, setdata] = useState(load);
  const [seperate, setseperate] = useState("");

  const all = () => {
    // console.log("law");
    setseperate("");
  };
  const law = () => {
    //console.log("law");
    setseperate("Law");
  };
  const students = () => {
    //console.log("law");
    setseperate("students");
  };
  const events = () => {
    // console.log("law");
    setseperate("events");
  };
  const infra = () => {
    //console.log("law");
    setseperate("Infastructure");
  };
  return (
    <React.Fragment>
      <Header></Header>
      <div className=" gallery-container">
        <div className="con">
          <div className="headings container" id="Heading">
            <h1>Gallery</h1>
          </div>

          <div className="ScriptTop">
            <div className="rt-container">
              <div className="col-rt-4" id="float-right"></div>
            </div>
          </div>

          <div className=" row" id="button-container">
            <button onClick={all}>All</button>
            <button onClick={law}>Law</button>
            <button onClick={students}>Students</button>
            <button onClick={events}>Events</button>
            <button onClick={infra}>Infrastructure</button>
          </div>

          <section>
            <div className="rt-container">
              <div className="col-rt-12">
                <div className="Scriptcontent">
                  <div className="container py-3">
                    <div className="gallery">
                      {data
                        .filter((value) =>
                          value.datagallerytag
                            .toLowerCase()
                            .includes(seperate.toLowerCase())
                        )
                        .map((value, index) => {
                          return (
                            <div key={index}>
                              <img
                                alt="Gallery 1"
                                data-gallery-tag={value.datagallerytag}
                                className="gallery-item"
                                src={value.link}
                                height="175vh"
                                width="300vw"
                              />
                            </div>
                          );
                        })}
                    </div>
                    <hr />
                    <i>more to come here...</i>
                  </div>
                  {/* <script src="assets/js/mauGallery.min.js"></script> */}
                  {/* <script src="assets/js/scripts.js"></script> */}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer></Footer>
    </React.Fragment>
  );
}

export default Gallery;
